import { DashboardLayout } from "@/components/dashboard-layout";
import { Card, CardContent } from "@/components/ui/card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/sbc-management")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "SBC Management",
    };
  },
});

function RouteComponent() {
  return (
    <DashboardLayout submenu={null}>
      <Card>
        <CardContent>
          <p className="text-md pb-20 pt-15 text-center">
            SBC management is not yet available in this client. To manage SBCs, please use the legacy admin client.
          </p>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
